import { getOfflineScreenEvents, updateOfflineScreenEvents } from '@/api/offlineEvents';
import { UNIQUE_SCREEN_IDENTIFIER } from '@/constants';
import {
  handleRestartDevice,
  handleTakeScreenshot,
  handleClearCache,
} from '@/utils/screenEventsHandler';
import { getDeviceInfo } from '@/helpers/utils';
import { isLoggedIn } from '@/services/auth';

export async function handleOfflineEvents() {
  if (isLoggedIn()) return;
  try {
    let screenIdentifier = localStorage.getItem(UNIQUE_SCREEN_IDENTIFIER);

    if (!screenIdentifier) {
      // To handle case where there is a local storage cleanup by the hardware.
      const deviceInfo = await getDeviceInfo();
      if (deviceInfo && deviceInfo.platformInfo && deviceInfo.platformInfo.serialNumber) {
        screenIdentifier = deviceInfo.platformInfo.serialNumber;
      }
    }

    if (!screenIdentifier) {
      return;
    }

    const events = await getOfflineScreenEvents(screenIdentifier);
    await handleEvents(screenIdentifier, events);
  } catch {
    // ignore
  }
}

async function handleEvents(screenIdentifier, events) {
  if (!events || !screenIdentifier) {
    return;
  }

  if (events.clear_cache) {
    await updateOfflineScreenEvents(screenIdentifier, { clear_cache: false });
    handleClearCache();
  }

  if (events.restart_device) {
    await updateOfflineScreenEvents(screenIdentifier, { restart_device: false });
    handleRestartDevice();
  }

  if (events.take_screenshot) {
    await updateOfflineScreenEvents(screenIdentifier, { take_screenshot: false });
    handleTakeScreenshot();
  }
}
